import cls from 'classnames'
import React, { useEffect, useState } from 'react'
import { isBrowser } from '../../../react-utils'
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '../../integration-builder/modal'
import { ExternalResourceIcon } from './external-resource-icon'
import { PostmanAstronaut } from './postman-astronaut'
import styles from './run-in-postman.module.css'
import { Button } from '@paypalcorp/pp-react'

interface RunInPostmanProps {
  text: string
  zIndex?: string
  newArchetype?: boolean
}

const POSTMAN_COLLECTION_URL =
  'https://elements.getpostman.com/view/fork?collection=19024122-92a85d0e-51e7-47da-9f83-c45dcb1cdf24&referrer=https%3A%2F%2Fdeveloper.paypal.com%2Fapi%2Frest%2F#?env%5BPayPal%20Override%20Env%5D=W3sia2V5IjoiUGxlYXNlIE5vdGUgLS0+IiwidmFsdWUiOiI8IFBheVBhbCBQdWJsaWMgQ29sbGVjdGlvbiBjb21lcyB3aXRoIGRlZmF1bHQgcHVibGljIHNldCBvZiBjcmVkZW50aWFscyBzdG9yZWQgYXQgdGhlIENvbGxlY3Rpb24gbGV2ZWwuIFxuVGhpcyBlbnZpcm9ubWVudCBvdmVycmlkZXMgdGhvc2UgZGVmYXVsdCB2YXJpYWJsZXMuIFlvdSBtYXkgYnJpbmcgeW91ciBvd24gY3JlZGVudGlhbHMgZnJvbSBQYXlQYWwgRGV2ZWxvcGVyIERhc2hib2FyZCBhbmQgcGFzdGUgdGhlbSBoZXJlLiBEbyBub3QgZm9yZ290IHRvIGVuYWJsZSB0aGUgdmFpYWJsZSBieSBjaGVja2luZyB0aGUgYm94IGFuZCBoaXQgXCJTYXZlXCIgYmVmb3JlIGludm9raW5nIHRoZSBQYXlQYWwgQVBJcy4gPiIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoiY2xpZW50X2lkIiwidmFsdWUiOiI8IGNvcHkgY3JlZGVudGlhbHMgZnJvbSB5b3VyIGRldmVsb3Blci5wYXlwYWwuY29tIGFuZCBwYXN0ZSB0aGVtIGhlcmUgPiIsImVuYWJsZWQiOmZhbHNlfSx7ImtleSI6ImNsaWVudF9zZWNyZXQiLCJ2YWx1ZSI6IjwgY29weSBjcmVkZW50aWFscyBmcm9tIHlvdXIgZGV2ZWxvcGVyLnBheXBhbC5jb20gYW5kIHBhc3RlIHRoZW0gaGVyZSA+IiwiZW5hYmxlZCI6ZmFsc2V9XQ=='

const POSTMAN_COLLECTION_VIEW_URL =
  'https://elements.getpostman.com/redirect?entityId=19024122-92a85d0e-51e7-47da-9f83-c45dcb1cdf24&entityType=collection&workspaceId=345300e6-346e-42e0-aed1-53717919aef0'

const RunInPostman: React.FC<RunInPostmanProps> = ({
  text,
  zIndex = '1450',
  newArchetype = false,
}) => {
  const [runInPostmanSwitch, setRunInPostmanSwitch] = useState(true)
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenInApp, setIsOpenInApp] = useState(false)

  useEffect(() => {
    if (
      window?.__INITIALDATA__?.runInPostmanFeatureSwitch &&
      window?.__INITIALDATA__?.runInPostmanFeatureSwitch ===
        'Trmt_Devdoc_RunInPostman_Button'
    ) {
      setRunInPostmanSwitch(true)
    }

    const postmanButton = document.getElementById('run-in-postman-button')
    postmanButton?.setAttribute('data-dxa', 'run-in-postman-button')
  })

  const handleShowPostmanModal = () => setIsOpen((prev) => !prev)
  const handleCloseModal = () => {
    setIsOpen(false)
    setIsOpenInApp(false)
  }
  const handleOpenPostmanApp = () => {
    setIsOpenInApp(!isOpenInApp)
  }

  if (!runInPostmanSwitch) return null

  return (
    <>
      {text && (
        <p style={{ marginBottom: newArchetype ? '8px' : '36px' }}>{text}</p>
      )}
      {newArchetype ? (
        <Button
          as="a"
          role="button"
          id="run-in-postman-button"
          onClick={handleShowPostmanModal}
          data-btn-type="pp-btn"
          data-pa-click="run_in_postman_button"
          data-postman-action="collection/fork"
          data-postman-var-1="19024122-92a85d0e-51e7-47da-9f83-c45dcb1cdf24"
          data-postman-collection-url="entityId=19024122-92a85d0e-51e7-47da-9f83-c45dcb1cdf24&entityType=collection&workspaceId=345300e6-346e-42e0-aed1-53717919aef0"
          data-postman-param="env%5BPayPal%20Override%20Env%5D=W3sia2V5IjoiUGxlYXNlIE5vdGUgLS0+IiwidmFsdWUiOiI8IFBheVBhbCBQdWJsaWMgQ29sbGVjdGlvbiBjb21lcyB3aXRoIGRlZmF1bHQgcHVibGljIHNldCBvZiBjcmVkZW50aWFscyBzdG9yZWQgYXQgdGhlIENvbGxlY3Rpb24gbGV2ZWwuIFxuVGhpcyBlbnZpcm9ubWVudCBvdmVycmlkZXMgdGhvc2UgZGVmYXVsdCB2YXJpYWJsZXMuIFlvdSBtYXkgYnJpbmcgeW91ciBvd24gY3JlZGVudGlhbHMgZnJvbSBQYXlQYWwgRGV2ZWxvcGVyIERhc2hib2FyZCBhbmQgcGFzdGUgdGhlbSBoZXJlLiBEbyBub3QgZm9yZ290IHRvIGVuYWJsZSB0aGUgdmFpYWJsZSBieSBjaGVja2luZyB0aGUgYm94IGFuZCBoaXQgXCJTYXZlXCIgYmVmb3JlIGludm9raW5nIHRoZSBQYXlQYWwgQVBJcy4gPiIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoiY2xpZW50X2lkIiwidmFsdWUiOiI8IGNvcHkgY3JlZGVudGlhbHMgZnJvbSB5b3VyIGRldmVsb3Blci5wYXlwYWwuY29tIGFuZCBwYXN0ZSB0aGVtIGhlcmUgPiIsImVuYWJsZWQiOmZhbHNlfSx7ImtleSI6ImNsaWVudF9zZWNyZXQiLCJ2YWx1ZSI6IjwgY29weSBjcmVkZW50aWFscyBmcm9tIHlvdXIgZGV2ZWxvcGVyLnBheXBhbC5jb20gYW5kIHBhc3RlIHRoZW0gaGVyZSA+IiwiZW5hYmxlZCI6ZmFsc2V9XQ=="
        >
          Run in Postman
        </Button>
      ) : (
        <button
          className={styles.postman_run_button}
          id="run-in-postman-button"
          onClick={handleShowPostmanModal}
          data-btn-type="postman-btn"
          data-pa-click="run_in_postman_button"
          data-postman-action="collection/fork"
          data-postman-var-1="19024122-92a85d0e-51e7-47da-9f83-c45dcb1cdf24"
          data-postman-collection-url="entityId=19024122-92a85d0e-51e7-47da-9f83-c45dcb1cdf24&entityType=collection&workspaceId=345300e6-346e-42e0-aed1-53717919aef0"
          data-postman-param="env%5BPayPal%20Override%20Env%5D=W3sia2V5IjoiUGxlYXNlIE5vdGUgLS0+IiwidmFsdWUiOiI8IFBheVBhbCBQdWJsaWMgQ29sbGVjdGlvbiBjb21lcyB3aXRoIGRlZmF1bHQgcHVibGljIHNldCBvZiBjcmVkZW50aWFscyBzdG9yZWQgYXQgdGhlIENvbGxlY3Rpb24gbGV2ZWwuIFxuVGhpcyBlbnZpcm9ubWVudCBvdmVycmlkZXMgdGhvc2UgZGVmYXVsdCB2YXJpYWJsZXMuIFlvdSBtYXkgYnJpbmcgeW91ciBvd24gY3JlZGVudGlhbHMgZnJvbSBQYXlQYWwgRGV2ZWxvcGVyIERhc2hib2FyZCBhbmQgcGFzdGUgdGhlbSBoZXJlLiBEbyBub3QgZm9yZ290IHRvIGVuYWJsZSB0aGUgdmFpYWJsZSBieSBjaGVja2luZyB0aGUgYm94IGFuZCBoaXQgXCJTYXZlXCIgYmVmb3JlIGludm9raW5nIHRoZSBQYXlQYWwgQVBJcy4gPiIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoiY2xpZW50X2lkIiwidmFsdWUiOiI8IGNvcHkgY3JlZGVudGlhbHMgZnJvbSB5b3VyIGRldmVsb3Blci5wYXlwYWwuY29tIGFuZCBwYXN0ZSB0aGVtIGhlcmUgPiIsImVuYWJsZWQiOmZhbHNlfSx7ImtleSI6ImNsaWVudF9zZWNyZXQiLCJ2YWx1ZSI6IjwgY29weSBjcmVkZW50aWFscyBmcm9tIHlvdXIgZGV2ZWxvcGVyLnBheXBhbC5jb20gYW5kIHBhc3RlIHRoZW0gaGVyZSA+IiwiZW5hYmxlZCI6ZmFsc2V9XQ=="
        />
      )}
      <Modal isOpen={isOpen} onClose={handleCloseModal}>
        <ModalOverlay zIndex={zIndex} bgOpacity="0.4" />
        <ModalContent modalWidth="440px" zIndex={zIndex} isCentered>
          <ModalHeader>
            {!isOpenInApp
              ? 'Fork collection into your workspace'
              : 'Importing collection...'}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {!isOpenInApp ? (
              <>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <ul className={styles.run_in_postman__list_container}>
                    <li className={styles.run_in_postman__list_item}>
                      Work in your own workspace or with your team
                    </li>
                    <li className={styles.run_in_postman__list_item}>
                      Stay up to date with the latest changes to the source
                      collection
                    </li>
                    <li className={styles.run_in_postman__list_item}>
                      Contribute to the source collection through pull requests
                    </li>
                  </ul>

                  <span>
                    <PostmanAstronaut />
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    paddingLeft: '2.3rem',
                  }}
                >
                  <span className={styles.run_in_postman__list_item}>
                    <a
                      href={POSTMAN_COLLECTION_VIEW_URL}
                      target="_blank"
                      style={{
                        color: '#6B6B6B',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      }}
                      rel="noreferrer"
                    >
                      View collection
                    </a>{' '}
                    in the public workspace first if you'd like to.
                  </span>
                  <span className={styles.run_in_postman__list_item}>
                    You can{' '}
                    <a
                      href={`postman:${POSTMAN_COLLECTION_URL}`}
                      onClick={handleOpenPostmanApp}
                      style={{
                        color: '#6B6B6B',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        border: 'none',
                        padding: '0',
                        background: 'transparent',
                      }}
                      target="_self"
                    >
                      import a copy
                    </a>{' '}
                    of the collection too.
                  </span>
                </div>{' '}
              </>
            ) : (
              <div className={styles.run_in_postman__open_app__container}>
                Your Postman desktop app should launch now and start importing
                the collection.
              </div>
            )}
          </ModalBody>

          <ModalFooter>
            {!isOpenInApp ? (
              <>
                {' '}
                <button
                  className={cls(
                    styles.run_in_postman__button,
                    styles.run_in_postman__button__cancel,
                  )}
                  onClick={handleCloseModal}
                >
                  Close
                </button>
                <button
                  className={cls(
                    styles.run_in_postman__button,
                    styles.run_in_postman__button__fork,
                  )}
                  onClick={() =>
                    isBrowser && window.open(POSTMAN_COLLECTION_URL, '_blank')
                  }
                >
                  Fork Collection
                </button>{' '}
              </>
            ) : (
              <span className={styles.run_in_postman__download_app__container}>
                Don't have the Postman desktop app?{' '}
                <a
                  href="https://www.postman.com/downloads/"
                  target="_blank"
                  style={{ color: '#D23F0E', textDecoration: 'none' }}
                  rel="noreferrer"
                >
                  Download Desktop App
                </a>
                <ExternalResourceIcon />
              </span>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default RunInPostman
